<template>
  <div class="home">
    <header class="header">
      <div class="header__sub-header">
        <img class="co-logo" alt="Flappy Sack Logo" src="../assets/deeznuts_logo.png">
        <div class="base-text header__presents">Presents</div>
        <FlappySackLogo />
      </div>
        <div class="base-text">
        <div class="text-center">Levels</div>
          <div class="levels">
            <div 
            @click="openView(level)" 
            class="levels__container base-text" 
            :class="{'level-disabled' : levels[index].unlockedAt > best }"
            v-for="(level, index) in levels.length" 
            :key="index"
            >
              <div class="level center-box" :style="{ backgroundImage: `url(${require(`../assets/levels/${level}/thumbnail.png`)}` }"></div>
              Stage {{level}}
            </div>
          </div>
        </div>
    </header>
  </div>
</template>

<script>
import FlappySackLogo from '@/components/svg/FlappySackLogo'

export default {
  name: 'Home',
  props: ['best', 'levels'],
  methods: {
    openView(level) {
      this.$parent.viewMode = 'game';
      this.$parent.level = level;
    }
  },
  computed: {
    hasLevels() {
      return this.best > 10 ? true : false;
    }
  },
  components: {
    FlappySackLogo
  }
}
</script>